import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import router from "@/router";
import { localForage } from "@/utils/services";
import { merge } from "lodash";
// import { networks } from '@/resources/data/base-networks'

@Module({ namespaced: true, name: "survey" })
export default class ModuleSurvey extends VuexModule {
    data: any = {};

    @Mutation
    store(survey: object) {
        this.data = merge(this.data, survey);
    }

    @Action
    process(uniqueId: string) {
        const survey = this.data[uniqueId];
        const files = this.context.rootState.files.data[uniqueId];

        // NOTE: this relies heavily on that route params object

        const processed = {
            surveyId: uniqueId,
            assetNo: survey.details.attributes0.assetNo,
            address: survey.details.attributes0.address,
            projectReference: survey.details.attributes0.projectReference,
            customerId: this.context.rootState.user.customerDetail.customerId,
            user: `${this.context.rootState.user.userDetail.firstName} ${
                this.context.rootState.user.userDetail.lastName
            }`,
            ownerid: this.context.rootState.user.userDetail.userId,
            // latitude: this.context.rootState.browser.geolocation.coordinates.latitude,
            // longitude: this.context.rootState.browser.geolocation.coordinates.longitude,
            latitude: survey.details.attributes0.lat,
            longitude: survey.details.attributes0.lng,
            type: router.currentRoute.query.type,
            // @ts-ignore - ts thinks network is a string. nope.
            network: router.currentRoute.params.network.code,
            status: "PE",
            surveyDate: new Date().toLocaleString("en-NZ"),
            data: survey,
            files: files.map((file: any) => file.name)
        };

        localForage.surveys.setItem(uniqueId, processed);
    }
}
